import { Link } from "react-router-dom";
import NewsletterForm from "@/components/NewsletterForm";

export default function Footer() {
    return (
        <footer
            className="bg-navy text-offwhite"
            data-testid="site-footer"
        >
            <div className="cap-container py-20 md:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
                    <div className="lg:col-span-5">
                        <div className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight text-offwhite mb-6">
                            Chief AI Partners
                        </div>
                        <p className="text-offwhite/70 max-w-md leading-relaxed" style={{ fontSize: "0.95rem" }}>
                            Fractional AI leadership for mid-market organisations
                            across Australia, New Zealand and the Pacific.
                        </p>
                        <div className="mt-8 space-y-1 text-offwhite/75 text-sm">
                            <div>Sanlux Pty Ltd trading as Chief AI Partners</div>
                            <div>Sydney, Australia</div>
                            <a
                                href="mailto:enquiries@chiefai.partners"
                                className="inline-block mt-2 border-b border-offwhite/40 hover:border-teal hover:text-teal transition-colors"
                                data-testid="footer-email-link"
                            >
                                enquiries@chiefai.partners
                            </a>
                        </div>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="text-[0.7rem] uppercase tracking-[0.22em] text-offwhite/50 font-semibold mb-5">
                            Explore
                        </div>
                        <ul className="space-y-3 text-offwhite/85 text-[0.95rem]">
                            <li><Link to="/services" data-testid="footer-link-services" className="hover:text-teal">Services</Link></li>
                            <li><Link to="/helm-framework" data-testid="footer-link-helm" className="hover:text-teal">Helm Framework</Link></li>
                            <li><Link to="/ai-opportunity-sprint" data-testid="footer-link-sprint" className="hover:text-teal">AI Opportunity Sprint</Link></li>
                            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-teal">About</Link></li>
                            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-teal">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <div className="text-[0.7rem] uppercase tracking-[0.22em] text-offwhite/50 font-semibold mb-5">
                            Newsletter
                        </div>
                        <p className="text-offwhite/75 text-sm leading-relaxed mb-5">
                            Get practical insights on AI leadership, implementation,
                            and operational efficiency.
                        </p>
                        <NewsletterForm variant="dark" />
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-offwhite/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[0.82rem] text-offwhite/55">
                    <div>
                        &copy; {new Date().getFullYear()} Sanlux Pty Ltd. All rights reserved.
                    </div>
                    <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                        <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-teal">Privacy Policy</Link>
                        <Link to="/terms" data-testid="footer-link-terms" className="hover:text-teal">Terms of Use</Link>
                        <Link to="/cookie-policy" data-testid="footer-link-cookie-policy" className="hover:text-teal">Cookie Policy</Link>
                        <button
                            type="button"
                            onClick={() => window.dispatchEvent(new CustomEvent("cap:open-cookie-prefs"))}
                            data-testid="footer-manage-cookies-btn"
                            className="hover:text-teal"
                        >
                            Manage Cookies
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
}
